<template>
  <div>
    <div class="form-group" :class="errorEntityType">
      <label class="control-label">Type of Entity</label>
      <dp-select :name="entityName"
                 :select-value="this.oldData.entity_type ? this.oldData.entity_type : initialData.entityType"
                 :initial-options="entityTypeOptions"
                 :disabled="false"
                 v-model="dataModel.entity_type"></dp-select>
    </div>
    <div class="form-group" :class="errorIncorporationJurisdiction">
      <label class="control-label">Jurisdiction of Incorporation or Organization</label>
      <dp-select :name="entityJurisdiction"
                 :select-value="this.oldData.incorporation_jurisdiction ? this.oldData.incorporation_jurisdiction : initialData.incorpJurisdiction"
                 :initial-options="jurisdictionOptions"
                 :disabled="false"
                 v-model="dataModel.incorporation_jurisdiction"></dp-select>
    </div>
    <div class="form-group" :class="errorBinNumber" v-show="dataModel.entity_type != 'trust' && dataModel.incorporation_jurisdiction == 'Canada'">
      <label class="control-label">{{ binLabel }}
      <modal-help>
        <ul>
          <li>The business number (BN) is a account number that identifies your business to federal, provincial, and municipal governments.</li>
          <li>Input the first 9 digits only, not any RC, RT, RC extensions.</li>
        </ul>
      </modal-help>
      </label>
      <dp-input :input-name="binNum" :input-value="this.oldData.bin_number ? this.oldData.bin_number : initialData.binNumber" :max-length="'9'" v-model="dataModel.bin_number"/>
    </div>
    <div class="form-group" :class="errorTrustNumber" v-show="dataModel.entity_type == 'trust' && dataModel.incorporation_jurisdiction == 'Canada'">
      <label class="control-label">{{ trustLabel }}
      <modal-help>The trust tax identification number is the eight-digit trust account number preceded by the letter “T” issued by the Canada Revenue Agency.</modal-help>
      </label>
      <div class="input-group">
        <span class="input-group-addon">T</span>
        <dp-input
            :input-type="'text'"
            :input-name="trustNum"
            :input-value="this.oldData.trust_number ? this.oldData.trust_number : initialData.trustNumber.slice(1)"
            :max-length="'8'"
            v-model="dataModel.trust_number" />
      </div>
    </div>
    <div class="form-group" :class="errorBinNumber" v-show="dataModel.incorporation_jurisdiction != 'Canada'">
      <label class="control-label">{{ tinLabel }}
        <modal-help>The tax identification number (TIN) is a account number that identifies your business.</modal-help>
      </label>
      <dp-input :input-name="tinNum" :input-value="this.oldData.tin_number_entity ? this.oldData.tin_number_entity : initialData.tinNumberEntity" :max-length="'25'" v-model="dataModel.tin_number_entity"/>
    </div>
  </div>
</template>

<script>
import DpInput from "./forms/DpInput";
import DpSelect from "./forms/DpSelect";
import ModalHelp from "./ModalHelp";

export default {
  name: "CorporateInformation",
  components: {
    ModalHelp,
    DpInput,
    DpSelect
  },
  props: {
    initialData: {
      binNumber: null,
      trustNumber: null,
      incorpJurisdiction: null,
      entityType: null,
      tinNumberEntity: null,
    },
    oldData: {
      bin_number: '',
      trust_number: '',
      incorporation_jurisdiction: '',
      entity_type: '',
      tin_number_entity: '',
    },
    errorState: ''
  },
  data() {
    return {
      entityName: 'entity_type',
      entityJurisdiction: 'incorporation_jurisdiction',
      binNum:'bin_number',
      tinNum: 'tin_number_entity',
      trustNum:'trust_number',
      binLength: 9,
      tinLength: 25,
      trustLength: 8,
      binLabel: 'Business Identification Number',
      tinLabel: 'Tax Identification Number',
      trustLabel: 'Trust Identification Number',
      binErrorMessage: 'The Business Identification Number has to be 9 digits long.',
      trustErrorMessage: 'The Trust Identification Number has to be 8 digits long.',
      entityOptions: [
        {value:'corporation',label:'Corporation'},
        {value:'partnership',label:'Partnership'},
        {value:'other',label:'Other'},
      ],
      trustOptions: [
        {value:'trust',label:'Trust'},
      ],
      jurisdictionOptions: [
        {value:'Canada',label:'Canada'},
        {value:'United States',label:'United States'},
        {value:'Foreign',label:'Foreign'}
      ],
      dataModel: {
        entity_type: this.oldData.entity_type ? this.oldData.entity_type : this.initialData.entityType,
        incorporation_jurisdiction: this.oldData.incorporation_jurisdiction ? this.oldData.incorporation_jurisdiction : this.initialData.incorpJurisdiction,
        bin_number: this.oldData.bin_number ? this.oldData.bin_number : this.initialData.binNumber,
        tin_number_entity: this.oldData.tin_number_entity ? this.oldData.tin_number_entity : this.initialData.tinNumberEntity,
        trust_number: this.oldData.trust_number ? this.oldData.trust_number : this.initialData.trustNumber,
      },
      hasErrors: {
        bin_number: false,
        tin_number_entity: false,
        trust_number: false,
        incorporation_jurisdiction: false,
        entity_type: false,
      }
    }
  },
  methods: {
    checkErrorState() {
      if(this.errorState !== '') {
        if(this.errorState.entity_type) {
          this.errorState.entity_type.length > 0 ? this.hasErrors.entity_type = true : this.hasErrors.entity_type = false
        }
        if(this.errorState.incorporation_jurisdiction) {
          this.errorState.incorporation_jurisdiction.length > 0 ? this.hasErrors.incorporation_jurisdiction = true : this.hasErrors.incorporation_jurisdiction = false
        }
        if(this.errorState.trust_number) {
          this.errorState.trust_number.length > 0 ? this.hasErrors.trust_number = true : this.hasErrors.trust_number = false
        }
        if(this.errorState.bin_number) {
          this.errorState.bin_number.length > 0 ? this.hasErrors.bin_number = true : this.hasErrors.bin_number = false
        }
        if(this.errorState.tin_number_entity) {
          this.errorState.tin_number_entity.length > 0 ? this.hasErrors.tin_number_entity = true : this.hasErrors.tin_number_entity = false
        }
      }

    },
    testInput(numLength,inputName) {
      let inputRegex = /^[0-9]{numLength}$/
      let inputResult = inputRegex.test(inputName)
    }
  },
  computed: {
    entityTypeOptions() {
      if(this.dataModel.entity_type === 'trust') {
        return this.trustOptions
      }
      return this.entityOptions
    },
    errorEntityType() {
      if (this.hasErrors.entity_type) {
        return 'error'
      }
      return ''
    },
    errorIncorporationJurisdiction() {
      if (this.hasErrors.incorporation_jurisdiction) {
        return 'error'
      }
      return ''
    },
    errorBinNumber() {
      if (this.hasErrors.bin_number) {
        return 'error'
      }
      return ''
    },
    errorTinNumber() {
      if (this.hasErrors.tin_number_entity) {
        return 'error'
      }
      return ''
    },
    errorTrustNumber() {
      if (this.hasErrors.trust_number) {
        return 'error'
      }
      return ''
    },
    inputLengthError() {
      return this.dataModel.bin_number.length < this.binLength || this.dataModel.tin_number_entity.length < this.tinLength
    }
  },
  created() {
    if(this.oldData.length !== 0) {
      this.dataModel = this.oldData
    }
      this.checkErrorState()
  }
}
</script>